module.exports = __webpack_public_path__ + "img/空白（页宽+动静态文字）.c78409ec.jpg";